import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY



export const getChecklistDiario = async (params) => {
    try {
        const response = await api.get(`${urlApi}/maintenance/checklist-diario`, { params });
        return response.data;
    } catch (error) {
        console.error("Error al obtener el checklist diario:", error);
        throw error;
    }   
}